import {global_shops} from "../addon/global_config";

export const fix_ads_mixins = {
  data() {
    return {
      is_floor: true,
      reduce_100k_list: ['broad_gmv', 'direct_gmv', 'cost', 'cpc', 'cpdc']
    }
  },

  beforeMount() {
    if (!this.shop) {
      console.error('Missing shop property in component:', this.$options.name)
    } else {
      const shop = this.shop

      if (shop && shop.extra_data && shop.extra_data.is_global && shop.extra_data.country) {
        const global_found = global_shops.find(i => i.country === shop.extra_data.country)
        if (global_found) {
          this.is_floor = global_found.is_floor
        }
      }
    }
  },

  methods: {
    m__currency() {
      const shop = this.shop

      if (shop && shop.extra_data && shop.extra_data.is_global && shop.extra_data.country) {
        const global_found = global_shops.find(i => i.country === shop.extra_data.country)
        if (global_found) return global_found.currency
      }

      return '₫'
    },

    m__calculate(arg, to_fixed = 2) {
      if (!arg) return 0

      arg = +arg

      const shop = this.shop

      if (shop && shop.extra_data && shop.extra_data.is_global && shop.extra_data.country) {
        const global_found = global_shops.find(i => i.country === shop.extra_data.country)
        if (global_found) {
          if (global_found.is_floor) {
            return Math.floor(arg)
          } else {
            return parseFloat(arg.toFixed(to_fixed))
          }
        }
      }

      return Math.floor(arg)
    },

    m__map_campaign_report(report) {
      report.atosa_cpc = {value: report.click.value !== 0 ? this.m__calculate(report.cost.value / report.click.value) : 0}
      report.cpm = {value: report.impression.value !== 0 ? this.m__calculate(report.cost.value / report.impression.value * 1000) : 0}
      report.aov = {value: report.broad_order.value !== 0 ? this.m__calculate(report.broad_gmv.value / report.broad_order.value) : 0}

      const impression = report.impression ? report.impression.value : 0
      const ctr = report.ctr ? report.ctr.value : 0
      const cr = report.cr ? report.cr.value : 0
      const action = impression * ctr * cr
      report.cpa = {value: action && report.cost ? this.m__calculate(report.cost.value / action) : 0}

      return report
    },

    m__map_detail_campaign_report(report) {
      report.position = 0
      report.seo_position = 0
      report.display_position = 0
      report.shopee_volume = 0

      report.average = Math.round(report.location_in_ads / report.impression) + 1
      report.cir = Number(report.broad_gmv) > 0 ? this.m__calculate(Number(report.cost) / Number(report.broad_gmv) * 100) : 0
      report.atosa_cpc = report.click !== 0 ? this.m__calculate(report.cost / report.click) : 0
      report.cpm = report.impression !== 0 ? this.m__calculate(report.cost / report.impression * 1000) : 0
      report.aov = report.broad_order !== 0 ? this.m__calculate(report.broad_gmv / report.broad_order) : 0

      const action = report.impression * report.ctr * report.cr
      report.cpa = action ? this.m__calculate(report.cost / action) : 0

      return report
    },

    m__map_graph_response(report_aggregate) {
      if (!report_aggregate) return {}

      const metrics = {...report_aggregate}
      metrics.broad_gmv = metrics.broad_gmv /= 100000
      metrics.cost /= 100000
      metrics.order = metrics.broad_order
      metrics.order_amount = metrics.broad_order_amount
      metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
      metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(2) : 0
      metrics.broad_roi = metrics.broad_roi ? +(metrics.broad_roi).toFixed(2) : 0
      metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
      metrics.cr = +metrics.click ? (+metrics.broad_order / +metrics.click * 100).toFixed(2) : 0
      metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
      metrics.aov = metrics.broad_order !== 0 ? this.m__calculate(metrics.broad_gmv / metrics.broad_order) : 0

      const action = metrics.impression * (metrics.ctr / 100) * (metrics.cr / 100)
      metrics.cpa = action ? this.m__calculate(metrics.cost / action) : 0

      return metrics
    },

    m__map_graph_by_time_response(report_by_time) {
      if (!report_by_time) return []

      return report_by_time.map(i => {
        const metrics = i.metrics
        metrics.broad_gmv = metrics.broad_gmv /= 100000
        metrics.cost /= 100000
        metrics.order = metrics.broad_order
        metrics.order_amount = metrics.broad_order_amount
        metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(2) : 0
        metrics.broad_roi = +(metrics.broad_roi).toFixed(2)
        metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
        metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
        metrics.aov = metrics.broad_order !== 0 ? this.m__calculate(metrics.broad_gmv / metrics.broad_order) : 0

        const action = metrics.impression * metrics.ctr * metrics.cr
        metrics.cpa = action ? this.m__calculate(metrics.cost / action) : 0

        return {timestamp: +i.key, ...metrics}
      })
    },

    m__map_search_report_by_key(response) {
      if (!response) return null

      if (!response.data) return []

      const data = response.data.map(i => {
        const metrics = {...i.metrics}
        metrics.broad_gmv /= 100000
        metrics.direct_gmv /= 100000
        metrics.cpc /= 100000
        metrics.cpdc /= 100000
        metrics.cost /= 100000
        metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
        metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
        metrics.aov = metrics.broad_order !== 0 ? this.m__calculate(metrics.broad_gmv / metrics.broad_order) : 0

        const action = metrics.impression * metrics.ctr * metrics.cr
        metrics.cpa = action ? this.m__calculate(metrics.cost / action) : 0

        return {keyword: i.key, ...metrics}
      })

      return {data}
    },

    m__map_targeting_report_by_key(response) {
      if (!response) return null

      if (!response.data) return []

      return response.data.map(i => {
        const metrics = {...i.metrics}
        metrics.broad_gmv /= 100000
        metrics.direct_gmv /= 100000
        metrics.cpc /= 100000
        metrics.cpdc /= 100000
        metrics.cost /= 100000
        metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
        metrics.aov = metrics.broad_order !== 0 ? this.m__calculate(metrics.broad_gmv / metrics.broad_order) : 0

        const action = metrics.impression * metrics.ctr * metrics.cr
        metrics.cpa = action ? this.m__calculate(metrics.cost / action) : 0

        let key = i.key
        if (key === 'daily_discover') key = '2'
        if (key === 'you_may_also_like') key = '5'
        if (key === 'targeting') key = '8'

        return {placement: key, ...metrics}
      })
    },

    m__map_shopee_campaign_type(campaign, include_all) {
      if (campaign.type === 'shop_manual') {
        return {
          shopee_type: 'shop',
          type: 'shop',
          bidding_type: 'manual'
        }
      }
      if (campaign.type === 'shop_auto') {
        return {
          shopee_type: 'shop',
          type: 'shop',
          bidding_type: 'auto'
        }
      }
      if (campaign.type === 'live_stream') {
        return {
          shopee_type: 'live_stream',
          type: 'live_stream',
          bidding_type: campaign.subtype
        }
      }
      if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'all') {
        return {
          shopee_type: 'product',
          type: include_all ? 'all' : 'keyword',
          bidding_type: campaign.manual_product_ads.bidding_strategy
        }
      }
      if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'search_product') {
        return {
          shopee_type: 'product',
          type: 'keyword',
          bidding_type: campaign.manual_product_ads.bidding_strategy
        }
      }
      if (campaign.manual_product_ads && campaign.manual_product_ads.product_placement === 'targeting') {
        return {
          shopee_type: 'product',
          type: 'targeting',
          bidding_type: campaign.manual_product_ads.bidding_strategy
        }
      }
    },

    m__map_campaign_data(response, include_all = false) {
      if (!response.data || !response.data.entry_list) return []

      const data = response.data.entry_list.map(i => {
        return {
          campaign: {
            campaignid: i.campaign.campaign_id, ...i.campaign,
            state: i.state,
            daily_quota: this.m__calculate(i.campaign.daily_budget / 100000),
            total_quota: 0,
            name: i.title,
            image_url: i.image,
            subtype: i.subtype,
            ...this.m__map_shopee_campaign_type(i, include_all),
          },

          advertisements: [],

          report: Object.keys(i.report).reduce((result, key) => {
            const ratio = i.ratio && i.ratio[key] ? i.ratio[key] : 0
            const value = this.reduce_100k_list.includes(key) ? this.m__calculate(i.report[key] / 100000) : i.report[key]
            result[key] = {
              ratio: ratio,
              value: value
            }

            return result
          }, {}),

          product: {
            itemid: i.manual_product_ads ? i.manual_product_ads.item_id : '',
            name: i.title,
            images: i.image
          },

          live_stream_ads: i.live_stream_ads,

          title: i.title,
          image: i.image,
          type: i.type,

          md5: i.manual_product_ads ? i.manual_product_ads.item_id : ''
        }
      })

      return {data: {campaign_ads_list: data}}
    },

    m__update_summary(summary) {
      if (summary.atosa_cpc) {
        summary.atosa_cpc = summary.click
          ? this.m__calculate(summary.cost / summary.click)
          : 0
      }
      if (summary.cpm) {
        summary.cpm = summary.impression
          ? this.m__calculate(summary.cost / summary.impression * 1000)
          : 0
      }
      if (summary.aov) {
        summary.aov = summary.broad_order
          ? this.m__calculate(summary.broad_gmv / summary.broad_order)
          : 0
      }
      if (summary.ctr) {
        summary.ctr = summary.impression
          ? summary.click / summary.impression
          : 0
      }
      if (summary.broad_cir) {
        summary.broad_cir = summary.broad_gmv
          ? summary.cost / summary.broad_gmv
          : 0
      }
      if (summary.direct_cir) {
        summary.direct_cir = summary.direct_gmv
          ? summary.cost / summary.direct_gmv
          : 0
      }
      if (summary.broad_roi) {
        summary.broad_roi = summary.cost
          ? summary.broad_gmv / summary.cost
          : 0
      }
      if (summary.direct_roi) {
        summary.direct_roi = summary.cost
          ? summary.direct_gmv / summary.cost
          : 0
      }
      if (summary.cr) {
        summary.cr = summary.click
          ? summary.broad_order / summary.click
          : 0
      }
      if (summary.direct_cr) {
        summary.direct_cr = summary.click
          ? summary.direct_order / summary.click
          : 0
      }
      if (summary.cpc) {
        summary.cpc = summary.broad_order
          ? summary.cost / summary.broad_order
          : 0
      }
      if (summary.cpdc) {
        summary.cpdc = summary.broad_order
          ? summary.cost / summary.direct_order
          : 0
      }
      if (summary.cpm) {
        summary.cpm = summary.impression
          ? this.m__calculate(summary.cost / summary.impression * 1000)
          : 0
      }
      if (summary.cpa) {
        const impression = summary.impression ? summary.impression : 0
        const ctr = summary.ctr ? summary.ctr : 0
        const cr = summary.cr ? summary.cr : 0
        const action = impression * ctr * cr
        summary.cpa = action ? this.m__calculate(summary.cost / action) : 0
      }
    },

    m__short_value(value, is_percent = false, is_rounded = true) {
      if (!value) return '0'
      if (!Number(value)) return value
      if (!is_percent && is_rounded) value = this.m__calculate(value)

      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''
      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return `${result} ${is_percent ? '%' : ''}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/fix_ads.js